import { render } from "./TextLabelStats.vue?vue&type=template&id=05a907ac&scoped=true&ts=true"
import script from "./TextLabelStats.vue?vue&type=script&lang=ts"
export * from "./TextLabelStats.vue?vue&type=script&lang=ts"

import "./TextLabelStats.vue?vue&type=style&index=0&id=05a907ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a907ac"]])

export default __exports__